export default __webpack_public_path__ + "static/media/Misery (blunt).611d3d39.jpg";